export const FETCH_STATE_REPORT_REQUEST = 'FETCH_STATE_REPORT_REQUEST';
export const FETCH_STATE_REPORT_DATA = 'FETCH_STATE_REPORT_DATA';
export const FETCH_STATE_REPORT_ERROR = 'FETCH_STATE_REPORT_ERROR';
export const RESET_STATE_REPORT_DATA = 'RESET_STATE_REPORT_DATA';
